import React from "react";
import { withRouter } from "./react/WithRouter";

import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Spinner from 'react-bootstrap/Spinner';
import ListGroup from "react-bootstrap/ListGroup";

import { Calendar } from 'primereact/calendar';

import DataTable from 'react-data-table-component';

import { faShareNodes, faMagnifyingGlassChart, faPlusSquare, faEllipsisVertical, faPencil, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import NewTestDialog from "./NewTestDialog"
import ControlTaskDialog from "./ControlTaskDialog"

import UserContext from '../context/UserContext';

class ControlTest extends React.Component {

	static contextType = UserContext;

	state = {	
		modified: false,
		isLoadingData: false,
		isLoadingWorkTask: false,
		selectedTask: 0,
		filterTask: new Date(),
		filterTest: new Date(),
		modal: '',
		canSign: false,
		controlTest: {
			riskName: "",
			controlName: "", 
			controlID: 0,
			controlDescription: "",

			taskIsWN:false,
			taskName: "",
			taskDescription: "",
			taskResponsible: 0,
			taskResponsibleName: "",
			taskTrigger: "",
			supportingEvidence: "",
			dependencyType: 0,
			dependencyName: "",
			supportingSystem: "",

			testInstruction: "",
			testFrequency: "",
			testerRoleID: 0,
			testerRole: "",

			testList: [],
			controlTaskList: [],
		},
	};


	componentDidMount() {
		var d = new Date();
		d.setFullYear(d.getFullYear() - 1);
		this.setState({ filterTask: d });
		this.setState({ filterTest: d });

		this.fetchControlTest(this.props.params.controlID);
	}

	componentDidUpdate(prevProps, prevState) {
		
	}

	fetchControlTest(controlID) {
		this.setState({ isLoadingData: true });
		fetch(`api/ControlTest/GetControlTest/` + controlID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.checkCanSign(data.testerRoleID);
				this.setState({ controlTest: data });
				this.setState({ isLoadingData: false });
			})
			.catch(error => {
				this.setState({ isLoadingData: false });
			})
	}


	fetchNewTest(testData) {
		const testProtocol = {comment: testData.comment, status: testData.status, controlID: this.state.controlTest.controlID }
		
		fetch('api/ControlTest/NewTest', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(testProtocol) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ modal: '' });
				this.fetchControlTest(this.state.controlTest.controlID)
			})
			.catch(error => {
				this.setState({ modal: '' });
			})
	}

	fetchTaskDetails(taskID) {
		this.setState({ isLoadingWorkTask: true });
		fetch(`api/ControlTest/GetTestTask/` + taskID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ isLoadingWorkTask: false });
			})
			.catch(error => {
				this.setState({ isLoadingWorkTask: false });
			})
	}

	checkCanSign(roleID) {
		const user = this.context.user;
		if (user.roleList.find(userRole => userRole.roleID === roleID)) {
			this.setState({ canSign: true });
		}
		
	}

	activateNewModal() {
		this.setState({ modal: 'newTest' });
	}

	menuPopup(row) {
		return (
			<Popover id="popover-basic" className="popup-menu shadow ">
				<Popover.Body>
					<ListGroup>
						<ListGroup.Item onClick={() => { document.body.click(); this.setState({modal: 'workTask' }); this.setState({selectedTask: row.taskID }); }}>
							<FontAwesomeIcon icon={faPencil} size="sm" /> Inspect
						</ListGroup.Item>
					</ListGroup>
				</Popover.Body>
			</Popover>
		);
	}

	customLoader() {
		return (
			<div style={{ padding: '24px' }}>
				<Spinner animation="border" />
				<div>Loading...</div>
			</div>
		);
	}


	handleCloseTestDialog(testData) {
		if (testData) {
			this.fetchNewTest(testData);
		} else {
			this.setState({ modal: '' });	
		}	
	}

	onDateChange(e, filter) {
		var checkDate = new Date(e.value);
		checkDate.setDate(checkDate.getDate() + 1);

		this.setState({ [filter]: new Date(e.value) });

		//const historyList = this.props.heatMapRisk.riskHistory;
		//var index = 0;

		//historyList.forEach((history, i) => { if (history.date.getTime() < checkDate.getTime()) index = i });
		//this.setState({ history: index });
	}

	filterTestList() {
		return (
			<Popover id="popover-basic" className="popup-menu shadow " style={{ maxWidth: '600px', width: 'auto' }}>
				<Popover.Body>
					<Calendar value={this.state.filterTest} onChange={(e) => { this.onDateChange(e,'filterTest'); document.body.click(); }} dateFormat="yy-mm-dd" inline maxDate={new Date()} />
				</Popover.Body>
			</Popover>
		);
	}


	filterTaskList() {
		return (
			<Popover id="popover-basic" className="popup-menu shadow " style={{ maxWidth: '600px', width: 'auto' }}>
				<Popover.Body>
					<Calendar value={this.state.filterTask} onChange={(e) => { this.onDateChange(e,'filterTask'); document.body.click(); }} dateFormat="yy-mm-dd" inline maxDate={new Date()} />
				</Popover.Body>
			</Popover>
		);
	}

	render() {
		const filteredDataTest = this.state.controlTest.testList.filter(test => new Date(test.date).getTime() > this.state.filterTest.getTime());
		const filteredDataWorkTasks = this.state.controlTest.controlTaskList.filter(task => new Date(task.closeTime).getTime() > this.state.filterTask.getTime());
		

		const customStyles = {
			headRow: {
				style: {
					border: 'none',
				},
			},
			headCells: {
				style: {
					color: '#202124',
					fontSize: '14px',
				},
			},
			rows: {
				highlightOnHoverStyle: {
					backgroundColor: 'AliceBlue',
					borderBottomColor: '#FFFFFF',
					borderRadius: '25px',
					outline: '1px solid #FFFFFF',
				},
			},
		};

		const testColumns = [
			{
				cell: (row) => <FontAwesomeIcon icon={faMagnifyingGlassChart} style={{ backgroundColor: row.statusColor, color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />,
				width: '2.75rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Status',
				selector: row => row.statusName,
				sortable: true,
				width: '8rem',
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Date',
				selector: row => { if (row.testStatus !== 0 ) { return row.date.split('T')[0] } else { return '' } },
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Signed by',
				selector: row => row.performedByName,
				sortable: true,
				width: '12rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Comment',
				selector: row => row.comment,
				sortable: true,
				grow: 2,
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
		];

		const workTaskColumns = [
			{
				cell: (row) => <FontAwesomeIcon icon={faShareNodes} style={{ backgroundColor: row.statusColor, color: 'white', padding: '0.3rem 0.35rem', borderRadius: '5px' }} />,
				width: '2.75rem', // custom width for icon button
				style: {
					borderBottom: '1px solid #FFFFFF',
					marginBottom: '-1px',
				},
			},
			{
				name: 'Status',
				selector: row => row.statusName,
				sortable: true,
				width: '8rem',
				style: {
					color: '#202124',
					fontSize: '14px',
					fontWeight: 500,
				},
			},
			{
				name: 'Closing date',
				selector: row => row.closeTime.split('T')[0],
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Deadline',
				selector: row => row.deadline.split('T')[0],
				sortable: true,
				width: '8rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Closed by',
				selector: row => row.closerName,
				sortable: true,
				width: '12rem',
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				name: 'Closing comment',
				selector: row => row.comment,
				sortable: true,
				grow: 2,
				style: {
					color: 'rgba(0,0,0,.54)',
				},
			},
			{
				cell: row => <OverlayTrigger trigger="click" rootClose placement='left' overlay={this.menuPopup(row)}>
					<Button variant="light" className="btn-circle" ><FontAwesomeIcon icon={faEllipsisVertical} /></Button>
				</OverlayTrigger>,
				allowOverflow: true,
				button: true,
				width: '3rem',
			},
		];


		return (
			<div>
				<NewTestDialog visible={this.state.modal === 'newTest'} onClose={this.handleCloseTestDialog.bind(this)} />
				<ControlTaskDialog visible={this.state.modal === 'workTask'} taskID={this.state.selectedTask} onClose={this.handleCloseTestDialog.bind(this)} />
				
				<Card className="workspace-card">
					<Card.Header>
						<div style={{ float: 'left' }}>
							<b>Control test - {this.state.controlTest.controlName}</b>
						</div>
					</Card.Header>
					<Card.Body>

						<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>

							<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>
								<Card className='rounded' style={{ width: '49%', minWidth: '20rem', marginRight: '2%', marginBottom: '1.5rem' }}>
									<Card.Header>
										<b>Control details</b>
									</Card.Header>
									<Card.Body>
										<b>Control description</b>
										<div>{this.state.controlTest.controlDescription}</div><br />
										<b>Test Instruction</b>
										<div>{this.state.controlTest.testInstruction}</div><br />
										<b>Test frequency</b>
										<div>{this.state.controlTest.testFrequency}</div><br/>
										<b>Test responsible</b>
										<div>{this.state.controlTest.testerRole}</div>
									</Card.Body>
								</Card>

								<Card className='rounded' style={{ width: '49%', minWidth: '20rem', marginBottom: '1.5rem' }} >
									<Card.Header>
										<b>Task/Action details</b>
									</Card.Header>
									{this.state.controlTest.taskIsWN ?
										<Card.Body>
											<b>WorkTask name</b>
											<div>{this.state.controlTest.taskName}</div><br />
											<b>Description</b>
											<div>{this.state.controlTest.taskDescription}</div><br />
											<b>Responsible</b>
											<div>{this.state.controlTest.taskResponsibleName}</div>
										</Card.Body>
										:
										<Card.Body>
											<b>Description</b>
											<div>{this.state.controlTest.taskDescription}</div><br />
											<b>Responsible</b>
											<div>{this.state.controlTest.taskResponsibleName}</div><br />
											<b>Trigger</b>
											<div>{this.state.controlTest.taskTrigger}</div><br />
											<b>Supporting evidence</b>
											<div>{this.state.controlTest.supportingEvidence}</div><br />
											<b>IT dependency</b>
											<div>{this.state.controlTest.dependencyName}</div><br />
											<b>Supporting system</b>
											<div>{this.state.controlTest.supportingSystem}</div>
										</Card.Body>
										}
								</Card>	
							</div>

							{this.state.controlTest.taskIsWN?
								<Card className="workspace-card" style={{ width: '100%', marginBottom: '1.5rem', maxHeight: '33%' }}>
								<Card.Header>
									<div style={{ float: 'left' }}>
										<b>WorkTask log</b>
									</div>
									<div style={{ float: 'right' }}>
											<OverlayTrigger trigger="click" rootClose placement='left' overlay={this.filterTaskList()}>
												<Button size='sm' onClick={() => { }} id={"btn_add"} variant="secondary" disabled={false}><FontAwesomeIcon icon={faFilter} /></Button>
											</OverlayTrigger>
									</div>
								</Card.Header>
								<Card.Body>
									<DataTable
										responsive
										className="data-table"
										columns={workTaskColumns}
										data={filteredDataWorkTasks}
										customStyles={customStyles}
										progressPending={this.state.isLoadingData}
										progressComponent={this.customLoader()}
										highlightOnHover
										pointerOnHover
										noHeader={true}
											onRowClicked={(row, event) => { this.setState({ modal: 'workTask' }); this.setState({ selectedTask: row.taskID });  }}
									/>
								</Card.Body>
							</Card>			
							:null}

							<Card className="workspace-card" style={{ width: '100%', maxHeight: '33%' }}>
								<Card.Header>
									<div style={{ float: 'left' }}>
										<b>Previous tests</b>
									</div>
									<div style={{ float: 'right' }}>
										<OverlayTrigger trigger="click" rootClose placement='left' overlay={this.filterTestList()}>
											<Button size='sm' onClick={() => { }} id={"btn_add"} variant="secondary" disabled={false}><FontAwesomeIcon icon={faFilter} /></Button>
										</OverlayTrigger>
										{this.state.canSign ? <Button size='sm' onClick={() => { this.activateNewModal() }} id={"btn_add"} variant="primary" disabled={false} style={{ marginLeft: '0.5rem' }}><FontAwesomeIcon icon={faPlusSquare} /> Sign new test </Button> : null}
									</div>
								</Card.Header>
								<Card.Body>
									<DataTable
										responsive
										className="data-table"
										columns={testColumns}
										data={filteredDataTest}
										customStyles={customStyles}
										progressPending={this.state.isLoadingData}
										progressComponent={this.customLoader()}
										highlightOnHover
										pointerOnHover
										noHeader={true}
										onRowClicked={(row, event) => { }}
									/>
								</Card.Body>
							</Card>
				
						</div>
					</Card.Body>
				</Card >
			</div>
		);
	}
}
export default withRouter (ControlTest);